export default __webpack_public_path__ + "static/media/dark_save_26.230e15af.svg";